import {TdoSubnavItemComponent} from './tdo-subnav-item/tdo-subnav-item.component';

export class TdoSubnavEvent {
  model: TdoSubnavItemComponent;
  name: string;

  constructor(pName: string, pModel: TdoSubnavItemComponent) {
    this.name = pName;
    this.model = pModel;
  }
}
